export default __webpack_public_path__ + "static/media/accounting-bot_vn_mobile.462591e7.png";